import React from 'react'
import SliderContainer from '../../../Components/BonusUi/Slider'

export default function Slider() {
    return (
        <div className='page-body'>
            <SliderContainer />
        </div>
    )
}
